module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.goOff()
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "arrow-left",
      "size": "1.5em"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600",
      "color": "#000"
    }
  }, [_vm._v("店铺信息")])], 1), _vm._v(" "), _c('van-cell-group', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('van-cell', {
    attrs: {
      "title": "企业名称",
      "value": _vm.org_name
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "营业执照",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.yulantupian()
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3de6c6c8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/menu/naturalendowments/Informationpage.vue
// module id = 561
// module chunks = 0